import { Button, Card, Col, Dropdown, ListGroup, Row } from 'react-bootstrap'
import './PackageList.scss'
import { scroller } from 'react-scroll'
import React from 'react'
import { useLayoutStore } from '../../../state/layout.store'
import { useTranslation } from 'react-i18next'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import usePackagesRepository from '../../../hooks/usePackagesRepository'

const PackageList = ({ packages }: { packages: PackageModel[] }) => {
  const openAddPackageModal = useLayoutStore(state => state.packageModalOpen)
  const { t } = useTranslation('packages')

  return (
    <Card className="package-list">
      <Card.Header className="d-flex">
        <div className="flex-grow-1">
          <h3 className="card-title d-flex align-items-center">
            <i className="fas fa-box-alt" />
            <span className="ms-1">{t('package-list.title')}</span>
          </h3>
        </div>
        <div>
          <Button variant="warning" size="sm" onClick={_ => openAddPackageModal(null)} className="text-white">
            <i className="fas fa-plus me-2" />
            {t('package-list.add package')}
          </Button>
        </div>
      </Card.Header>
      <ListGroup variant="flush">
        {Object.entries(packages).map(([key, pkg], i) => (
          <ListGroup.Item
            className="pointer list-group-item-action"
            onClick={e => handleOnClick(e, pkg.computedKey)}
            key={i}
          >
            <Row className="align-items-center">
              <Col>
                {pkg.isDescriptionEmpty() ? (
                  <>
                    <h4 className="pkg-name mb-0">{pkg.trackingId}</h4>
                    <span className="pkg-id-extra text-muted">{pkg.getExtraDataString()}</span>
                  </>
                ) : (
                  <>
                    <h4 className="pkg-name mb-0">{pkg.getDescription()}</h4>
                    <span className="pkg-id text-black-50">{pkg.trackingId}</span>
                    <span className="pkg-id-extra text-muted ms-1">{pkg.getExtraDataString()}</span>
                  </>
                )}
              </Col>
              <Col xs="auto">
                <OptionsDropdown pkg={pkg} index={1} />
              </Col>
            </Row>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  )
}

const handleOnClick = (e, id) => {
  e.preventDefault()

  scroller.scrollTo(id, {
    duration: 200,
    delay: 0,
    smooth: 'easeInOutQuart',
    offset: -50,
  })
}

const OptionsDropdown = React.memo(({ pkg, index }: { pkg: PackageModel; index: number }) => {
  const packageModal = useLayoutStore(state => state.packageModalOpen)
  const pkgShareToggle = useLayoutStore(state => state.packageShareModalToggle)

  const pkgsRepo = usePackagesRepository()
  const { t } = useTranslation('packages')

  return (
    <div onClick={stopPropagation}>
      <Dropdown>
        <Dropdown.Toggle variant="light" id={'dropdown-package-card-' + index}>
          <i className="fas fa-cog text-secondary" />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item onClick={() => packageModal(pkg)}>
            <i className="fas fa-edit me-2" />
            {t('package-list.edit')}
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => {
              pkgShareToggle(pkg)
            }}
          >
            <i className="fas fa-external-link-alt me-2" />
            {t('package-list.share')}
          </Dropdown.Item>
          {/*<Dropdown.Item className="text-muted">*/}
          {/*  <i className="fas fa-check me-2" />*/}
          {/*  Mark as Delivered*/}
          {/*</Dropdown.Item>*/}
          <Dropdown.Item onClick={() => pkgsRepo.removePackage(pkg)}>
            <i className="fas fa-trash me-2" />
            {t('package-list.remove')}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
})

const stopPropagation = e => e.stopPropagation()

export default PackageList
